import { InputAdornment, TextFieldProps } from "@mui/material";
import { phoneCountry } from "../../constants/phoneCountries";
import { currencyUnit } from "../../utils/formatCurrency";

// The unit and dial code are shown beside the box, never typed into it, so
// the value in state stays the bare digits the payment call expects. Both
// follow the data: the unit is the service's currency, the dial code the
// selected country's, so neither can disagree with the hint or the selector.
export const currencyAdornment = (
  currency?: string
): TextFieldProps["slotProps"] => ({
  input: {
    endAdornment: (
      <InputAdornment position="end">{currencyUnit(currency)}</InputAdornment>
    ),
  },
});

// A country the registry does not know shows no dial code rather than a
// guessed one.
export const dialCodeAdornment = (
  countryCode: string
): TextFieldProps["slotProps"] => {
  const dialCode = phoneCountry(countryCode)?.dialCode;
  return dialCode
    ? {
        input: {
          startAdornment: (
            <InputAdornment position="start">{dialCode}</InputAdornment>
          ),
        },
      }
    : undefined;
};
